import { FileType } from '@webapp/account/src/resources/tasks';

export enum ReportType {
    TABLES_AND_DIAGRAMS = 1,
    CONSOLIDATED_REPORT = 2,
    SINGLE_ANSWERS = 3,
}

export const formatsPerType = {
    [ReportType.TABLES_AND_DIAGRAMS]: [FileType.PDF, FileType.XLSX],
    [ReportType.CONSOLIDATED_REPORT]: [FileType.CSV, FileType.XLSX, FileType.SPSS],
    [ReportType.SINGLE_ANSWERS]: [FileType.PDF],
};

export const reportOptions = [
    { label: 'Таблицы и диаграммы', value: ReportType.TABLES_AND_DIAGRAMS },
    { label: 'Сводная таблица', value: ReportType.CONSOLIDATED_REPORT },
    { label: 'Отдельные ответы', value: ReportType.SINGLE_ANSWERS },
];

export const fileTypes = [
    { label: 'PDF', value: FileType.PDF },
    { label: 'SPSS', value: FileType.SPSS },
    { label: 'CSV', value: FileType.CSV },
    { label: 'XLSX', value: FileType.XLSX },
];
